
import { TableBody, TableCell, TableRow } from "@/components/ui/table";
import { SchoolUser } from "@/types/users";
import { UserTableRow } from "./UserTableRow";

interface TableContentProps {
  loading: boolean;
  users: SchoolUser[];
  searchQuery: string;
  usersWithStatus: (SchoolUser & {
    hasUnpaidBills?: boolean;
    hasActiveSubscription?: boolean;
  })[];
  onDelete: (user: SchoolUser) => void;
  onUserUpdated: () => void;
}

export const TableContent = ({
  loading,
  users,
  searchQuery,
  usersWithStatus,
  onDelete,
  onUserUpdated,
}: TableContentProps) => {
  if (loading) {
    return (
      <TableBody>
        <TableRow>
          <TableCell colSpan={6} className="text-center py-4">
            Loading...
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }

  if (users.length === 0) {
    return (
      <TableBody>
        <TableRow>
          <TableCell colSpan={6} className="text-center py-4">
            {searchQuery ? "No matching users found" : "No users found"}
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }

  return (
    <TableBody className="[&>tr:last-child]:border-0">
      {usersWithStatus.map((user) => (
        <UserTableRow
          key={user.id}
          user={user}
          onDelete={onDelete}
          onUserUpdated={onUserUpdated}
        />
      ))}
    </TableBody>
  );
};
